


















































































































































































import { Vue, photosUrlEnum } from "../../constants/constants";
import { staticContent } from "../../localisation/detect-lang";

export default Vue.component("order-share", {
 
  data() {
    return {
      staticContent,
      photosUrlEnum,
    };
  },
  props: ["page"],
  computed: {
    selectedOrder() {
      return this.$store.state.selectedOrder;
    },
  },

  methods: {
    countItems(){
      let count=0;
      this.selectedOrder.data.categories.map(elm=>{
      count+=elm.items.length;
    })
    return count
    },
    modalToggler(modalId, action) {
      this.$root.modalToggler(modalId, action);
    },
    toFixedPrice(price) {
      return this.$root.toFixedPrice(price);
    },
    newCalcExtrasTotalPrice(total) {
      return this.$root.newCalcExtrasTotalPrice(total);
    },
    getURL(url) {
      return this.$root.updatePhotosURL(
        url,
        this.$root.photosUrlEnum.version.thumbnail
      );
    },
    reOrder(UUID) {
      this.$root.handleReOrder(UUID);
    },
  
  },
});
